export const FeeScheduleFragment = gql`
  fragment FeeScheduleFragment on FeeSchedule {
    id
    name
    effectiveDate
    isCurrent
    numUnarchivedFeeTemplates
    notDeletableReason
  }
`
